module.exports = __webpack_public_path__ + "assets/jiandan.2df45966.svg";